import React from "react";
import { Routes, Route } from "react-router-dom";
import ReportLayout from "./ReportLayout";
import Introduction from "./Introduction";
import Strengths from "./Strengths";
import Development from "./Development";
import Input from "./Input";
import Processes from "./Processes";
import ClimateCulture from "./ClimateCulture";
import PlcGroup from "./PlcGroup";
import Recommendations from "./Recommendations";
import Overview from "./Overview";

const ReportRoutes = ({ isHub, basePathPrefix }) => {
  return (
    <Routes>
      <Route path=":organizationSurveyId/*" element={<ReportLayout isHub={isHub} basePathPrefix={basePathPrefix} />}>        
        <Route index element={<Introduction />} />
        <Route path="introduction" element={<Introduction />} />
        <Route path="report" element={<Overview isHub={isHub} />} />
        <Route path="strengths" element={<Strengths />} />
        <Route path="development" element={<Development />} />
        <Route path="input" element={<Input />} />
        <Route path="processes" element={<Processes />} />
        <Route path="climate-culture" element={<ClimateCulture />} />
        <Route path="plc-group" element={<PlcGroup />} />
        <Route path="recommendations" element={<Recommendations />} />
      </Route>
    </Routes>
  );
};

export default ReportRoutes;
